<div class="legend-container pt-2">
  <div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-12 col-sm-12 py-2 px-4">
      <h3 class="text-center sub-header">JOB COUNT</h3>
      <div class="circle mx-1">#</div>
    </div>
  </div>

  <div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-12 col-sm-12 py-2 px-4">
      <h3 class="text-center sub-header">TAGS</h3>
      <div class="row align-items-start legend-sub-container">
        <div class="flex">
          <div>
            <ul class="list-group">
              <li *ngFor="let tag of tags" class="list-group-item">
                <app-job-board-tags
                  (delete)="deleteTag($event)"
                  [tag]="tag"
                  [tagShape]="tag?.shape"></app-job-board-tags>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-12 col-sm-12 py-2 px-4">
      <h3 class="text-center sub-header">EMPLOYEE TYPES</h3>
      <div class="row align-items-start legend-sub-container">
        <div *ngFor="let title of employeeTypes">
          <app-job-employee-title [employeeTitle]="title"></app-job-employee-title>
        </div>
      </div>
    </div>
  </div>
</div>
